import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  selectInputSelector: '[data-comp-select-filter-group-select]',
  filterInputSelector: '[data-comp-select-filter-group-filter]',
};

export default class SelectFilterGroup extends Component {
  static selector = '[data-comp-select-filter-group]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.selectInput = this.$container.querySelector(
      this.$options.selectInputSelector,
    );

    this.filterInput = this.$container.querySelector(this.$options.filterInputSelector);
    this.initListeners();
  }

  initListeners() {
    this.filterInput.addEventListener('keyup', (event) => {
      for (const option of this.selectInput.options) {
        option.hidden = !option.text.toLowerCase().match(event.target.value.toLowerCase());
      }
    });
  }
}
